(() => {
  let config = document.getElementById('VapevoFroonzeStockLabel');
  if (!config || window.vapevoFroonzeStockLabelLoaded) return;
  window.vapevoFroonzeStockLabelLoaded = true;

  const buttonSelector = '.frcp-wishlist-product-btn';
  const contentSelector = `${buttonSelector}, [data-selected-variant]`;
  const relevantSelector = `${contentSelector}, variant-picker`;
  let productInfo = null;
  let frame = 0;
  let variantJSON;
  let cachedVariant = null;
  const observer = new MutationObserver((records) => {
    if (records.some(isRelevantMutation)) schedule();
  });

  function isRelevantMutation(record) {
    if (record.type === 'attributes') return record.target.matches(buttonSelector);

    const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
    if (target?.closest(contentSelector)) return true;

    return [...record.addedNodes, ...record.removedNodes].some((node) =>
      node.nodeType === 1 && (node.matches(relevantSelector) || node.querySelector(relevantSelector))
    );
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      update();
    });
  }

  function reconnect() {
    observer.disconnect();
    productInfo = null;
    schedule();
  }

  function selectedVariant() {
    const marker = productInfo.querySelector('[data-selected-variant]');
    if (marker) {
      const json = marker.textContent;
      if (json !== variantJSON) {
        variantJSON = json;
        try {
          const variant = JSON.parse(json);
          cachedVariant = variant && typeof variant.available === 'boolean' ? variant : null;
        } catch {
          cachedVariant = null;
        }
      }
      return cachedVariant;
    }

    if (productInfo.querySelector('variant-picker') || !config.dataset.variantId) return null;
    return {
      id: config.dataset.variantId,
      available: config.dataset.available === 'true'
    };
  }

  function update() {
    if (!config?.isConnected) config = document.getElementById('VapevoFroonzeStockLabel');
    if (!config) {
      observer.disconnect();
      productInfo = null;
      return;
    }

    if (!productInfo?.isConnected || productInfo.dataset.productId !== config.dataset.productId) {
      observer.disconnect();
      variantJSON = undefined;
      cachedVariant = null;
      productInfo = Array.from(document.querySelectorAll(
        'main product-info[data-update-url="true"][data-product-id]'
      )).find((element) => element.dataset.productId === config.dataset.productId) || null;
      if (productInfo) {
        observer.observe(productInfo, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['data-frcp-in-wishlist', 'data-frcp-variant-id']
        });
      }
    }

    if (!productInfo) return;
    const wishlist = window.frcp?.wishlist;
    const texts = wishlist?.textsWithDefaults?.button || wishlist?.texts?.button;
    if (!texts) return;

    const variant = selectedVariant();
    productInfo.querySelectorAll(buttonSelector).forEach((button) => {
      if (button.dataset.frcpProductId !== config.dataset.productId) return;

      const saved = button.dataset.frcpInWishlist === 'true';
      let text = saved ? texts.remove_text : texts.add_text;
      if (
        !saved &&
        variant?.available === false &&
        button.dataset.frcpVariantId === String(variant.id)
      ) {
        text = config.dataset.restockLabel;
      }

      if (typeof text !== 'string' || !text.trim()) return;
      const label = button.querySelector('.frcp-wishlist-btn__text');
      if (label && label.textContent !== text) label.textContent = text;
      if (button.getAttribute('aria-label') !== text) button.setAttribute('aria-label', text);
      if (button.getAttribute('title') !== text) button.setAttribute('title', text);
    });
  }

  document.addEventListener('variant:change', schedule, true);
  [
    'frcp.wishlist.initialize',
    'frcp.wishlist.installed',
    'frcp.wishlist.update',
    'frcp.locationChange'
  ].forEach((name) => document.addEventListener(name, schedule));
  [
    'product-info:loaded',
    'shopify:section:load',
    'shopify:section:unload',
    'theme:loading:end'
  ].forEach((name) => document.addEventListener(name, reconnect));
  schedule();
})();
